import { Menu } from '@styled-icons/boxicons-regular/Menu'
import { BookBookmark } from '@styled-icons/boxicons-regular/BookBookmark'
import { AccountCircle } from '@styled-icons/material/AccountCircle'
import { Bell } from '@styled-icons/boxicons-regular/Bell'

export default [
  {
    icon: BookBookmark,
    text: 'OnLearning',
    children: [
      {
        text: 'Aula',
        path: '/aula',
      },
    ],
  },
  {
    icon: Menu,
    text: 'Plataforma',
    children: [
      {
        text: 'Meus cursos',
        path: '/meus-cursos',
      },
      {
        text: 'Feed',
        path: '/feed',
      },
      {
        text: 'Ajuda',
        path: '/ajuda',
      },
    ],
  },
  {
    icon: Bell,
    text: 'Notificações',
    path: '/notificacoes',
    children: [],
  },
  {
    icon: AccountCircle,
    text: 'Perfil',
    children: [
      {
        text: 'Minha conta',
        path: '/perfil',
      },
      {
        text: 'Subscrição',
        path: '/subscricao',
      },
      {
        text: 'Sair',
        path: '/',
      },
    ],
  },
]
